import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class RoomTypeService {
    static getRoomTypes(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`room-types?filter=${qs}`, pageNumber));
    }
    static fetchRoomType(oid) {
        return lastValueFrom(BaseService.get(`room-types/${oid}`));
    }
    static saveRoomType(dto) {
        return lastValueFrom(BaseService.save(`room-types`, dto));
    }
    static deleteRoomType(oid) {
        return lastValueFrom(BaseService.delete(`room-types/${oid}`));
    }
    static searchRoomTypeCombo(selfId, plantId, phaseCode, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`room-types-search-dropdown/${selfId}/${plantId}/${phaseCode}?search=${qs}`));
    }
}
